import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";

const CustomPopup2 = ({ isOpen, onClose, children }) => {
  if (typeof window === "undefined") return null;

  return createPortal(
    <>
      <style>
        {`
          .custom-popup-overlay {
            position: fixed;
            inset: 0;
            z-index: 1000;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .custom-popup-backdrop {
            position: absolute;
            inset: 0;
            background-color: rgba(0, 0, 0, 0.5);
          }

          .custom-popup-content {
            position: relative;
            z-index: 10;
            background-color: #fff;
            border-radius: 12px;
            padding: 24px;
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
            max-width: 500px;
            width: 100%;
          }
        `}
      </style>

      <AnimatePresence>
        {isOpen && (
          <div className="custom-popup-overlay">
            {/* Backdrop */}
            <motion.div
              className="custom-popup-backdrop"
              onClick={onClose}
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              exit={{ opacity: 0 }}
            />

            {/* Popup Content */}
            <motion.div
              className="custom-popup-content"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 50, opacity: 0 }}
              transition={{ type: "spring", damping: 20, stiffness: 300 }}
            >
              {children}
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </>,
    document.body
  );
};

export default CustomPopup2;
